export function isEmptyOrSpaces(str: string): boolean{
    return str === null || /^ *$/.test(str);
}